export default {"src":"/login-app/[GIT_HASH]/_next/static/media/preview_tick.3137c074.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};